import { render, staticRenderFns } from "./shift-form-additional.vue?vue&type=template&id=65f0ea1a&scoped=true&"
import script from "./shift-form-additional.vue?vue&type=script&lang=js&"
export * from "./shift-form-additional.vue?vue&type=script&lang=js&"
import style0 from "./shift-form-additional.vue?vue&type=style&index=0&id=65f0ea1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0ea1a",
  null
  
)

export default component.exports